/** English customer-facing copy. Plain punctuation: no em dashes. */
export const en = {
  brandSub: 'Moving & Storage · Florida',
  langSwitch: 'Español',
  langSwitchAria: 'Cambiar a español',
  callKyle: 'Call IMF Florida Local Movers',
  aiLabel: 'AI-assisted phone support',
  humanHelp: 'Talk to a person',
  callShort: 'Call',
  homeTitle1: 'Moving in Florida?',
  homeTitle2: 'Plan your move. See your estimate. Book from your phone.',
  homeSub: 'Choose your home, add your items, select your services and reserve online. No phone call needed. Prefer to talk? Call us for assistance.',
  homeSubPreview: 'Choose your home, add your items, select your services and see your itemized estimate online. No phone call needed. Prefer to talk? Call us for assistance.',
  homeSteps: 'Choose your move. Review your pricing. Sign online. Reserve securely.',
  homeStepsPreview: 'Choose your move. Review your pricing. Send your plan. We confirm documents and your deposit with you.',
  promise: 'Configure and reserve your move from your phone. No phone call needed. Assistance is available whenever you prefer to talk.',
  promisePreview: 'Configure your move and see your estimate from your phone. No phone call needed. Assistance is available whenever you prefer to talk.',
  homeArea: 'Tampa, Orlando, Ocala, Sarasota and approved Florida routes.',
  homeAreaDetail: 'We check pickup, delivery and every stop against our service area while you plan.',
  card1: 'Studio / 1 Bedroom',
  card2: '2 Bedrooms',
  card3: '3 Bedrooms',
  card4: '4 Bedrooms',
  crewHint2: 'Usually 2 movers',
  crewHint23: '2 or 3 movers',
  crewHint3: 'Often 3 movers',
  crewHint3r: '3 movers, reviewed with you',
  more5: '5+ bedrooms',
  fewItems: 'Only a few items',
  ctaBuild: 'Build My Move',
  howTitle: 'How it works',
  how1: 'Tell us about your move',
  how1Body: 'Rooms, addresses, stairs or elevator, and what you’re moving.',
  how2: 'Review your estimate',
  how2Body: 'Crew, estimated hours and each charge itemized before you decide.',
  how3: 'Sign and reserve with $99',
  how3Body: 'The deposit is credited to your final bill.',
  how3Preview: 'Send your plan',
  how3PreviewBody: 'Our team confirms availability, documents and your $99 deposit with you.',
  ratesTitle: 'Hourly rates',
  rate2: '2 movers + 1 truck',
  rate3: '3 movers + 1 truck',
  perHour: '/hour',
  ratesNote: '4-hour service minimum, plus 1 billed travel hour and a 20% operating surcharge. Card payments carry a 4% charge. Packing and materials are priced separately.',
  helpQuick: 'Quick answers',
  stepSize: 'Home',
  stepAddresses: 'Addresses',
  stepAccess: 'Access',
  stepInventory: 'Inventory',
  stepPacking: 'Packing & truck',
  stepDate: 'Date',
  stepContact: 'Contact',
  stepEstimate: 'Estimate',
  stepReserve: 'Reserve',
  stepStatus: 'Status',
  back: 'Back',
  next: 'Continue',
  acceptContinue: 'Accept estimate & continue',
  summary: 'Your move',
  close: 'Close',
  saved: 'Progress saved on this device',
  editDetails: 'Edit',
  sizeTitle: 'What are you moving?',
  typeLabel: 'Property type',
  htApartment: 'Apartment',
  htHouse: 'House',
  htTownhome: 'Townhouse',
  htOffice: 'Office / special move',
  bedTitle: 'How many bedrooms?',
  bedStudio: 'Studio',
  bedOne: '1 bedroom',
  bedMany: '{n} bedrooms',
  bed5: '5+ bedrooms',
  bedFew: 'Only a few items',
  adNote: 'We started with the size from your ad. Change it anytime.',
  suggestTitle: 'Common items for this home',
  suggestBody: 'Tap to add what you actually have. Nothing is added unless you choose it.',
  addAll: 'Add all suggestions',
  added: 'Added',
  addrTitle: 'Where are you moving?',
  addrIntro: 'Pickup and delivery. Keep the apartment, building and complex details separate from the street address.',
  fromLabel: 'Pickup',
  toLabel: 'Delivery',
  streetLabel: 'Street address',
  unitLabel: 'Apt / unit',
  zipLabel: 'ZIP code',
  addrManual: 'Typed addresses aren’t verified yet. Our team checks them before any reservation.',
  zoneIncomplete: 'Enter the ZIP code for every location to check coverage.',
  zoneCore: 'This route is in our main service area around Tampa, Orlando, Ocala and Sarasota. We confirm the exact road route before reserving.',
  zoneCorridor: 'This is one of our longer Florida routes. Online reservation is available, and our team adds a transportation estimate before you pay.',
  zoneCorridorSmall: 'Longer Florida routes are available online for 2 bedrooms or more. Continue and our team will review options for your move.',
  zoneMiami: 'Miami moves of 2 to 4 bedrooms can be reserved online. Our team adds a transportation estimate before you pay.',
  zoneMiamiSmall: 'For Miami, online reservation is available for 2 to 4 bedrooms. Continue and our team will review options for your move.',
  zonePending: 'Part of this route needs a coverage check by our team before reserving. Continue and we’ll keep your plan.',
  zonePanhandle: 'We don’t take online reservations for Tallahassee, Panama City or the Panhandle. Continue and our team will review options with you.',
  zoneOutside: 'This route is outside our Florida service area. Continue and our team will review options with you. No deposit is taken for it.',
  zoneLarge: 'Homes with 5 or more bedrooms are reviewed by our team before reserving.',
  accessTitle: 'Access at pickup and delivery',
  accessIntro: 'Stairs, elevators, parking and walking distance change the time and crew. “Ground floor” means street level.',
  originHome: 'Pickup',
  destHome: 'Delivery',
  floorLabel: 'What level is it on?',
  flGround: 'Ground floor (street level)',
  flSecond: '2nd floor',
  flThird: '3rd floor',
  flFourth: '4th floor or higher',
  methodLabel: 'How do we get there?',
  mStairs: 'Stairs',
  mPassenger: 'Passenger elevator',
  mFreight: 'Freight / service elevator',
  flightsLabel: 'Flights of stairs',
  elevResLabel: 'Must the elevator be reserved?',
  sharedElevLabel: 'Shared with residents during the move?',
  truckNearLabel: 'Can the truck park legally near the entrance?',
  gateLabel: 'Gate code or HOA restrictions?',
  coiLabel: 'Does the building require a certificate of insurance (COI)?',
  parkingLabel: 'Where can the truck park legally?',
  pkDriveway: 'Driveway',
  pkStreet: 'Street',
  pkLot: 'Parking lot',
  pkDock: 'Loading dock',
  pkUnsure: 'Not sure',
  innerCarryLabel: 'Extra distance inside: hallways, to the elevator, or elevator to the door',
  restrictionsLabel: 'Building access restrictions (optional)',
  loadingHoursLabel: 'Parking or loading time limits (optional)',
  yes: 'Yes',
  no: 'No',
  unsure: 'Not sure',
  carryLabel: 'Distance from truck parking to the building entrance',
  carryHelp: 'An approximate answer is fine. Don’t include floor height.',
  cb0_20: '0–20 ft',
  cb21_40: '21–40 ft',
  cb41_60: '41–60 ft',
  cb61_100: '61–100 ft',
  cbover_100: 'Over 100 ft',
  cbunsure: 'Not sure',
  car1: '≈ 1 car length',
  car2: '≈ 2 car lengths',
  car4: '≈ 4 car lengths',
  car6: '≈ 4–7 car lengths',
  car7: 'more than 7',
  carNone: 'measure later',
  carNote: 'A compact sedan is about 15 ft long. Approximate only.',
  feetLabel: 'Exact feet (optional)',
  accessNotesLabel: 'Anything else for dispatch (truck limits, house color, directions)',
  invTitle: 'What are we moving?',
  invIntro: 'Choose items room by room. Suggestions are only ideas. You decide what’s included.',
  suggested: 'Suggested',
  addSuggestedRoom: 'Add suggestions for this room',
  invItems: '{n} items',
  decrease: 'Decrease',
  increase: 'Increase',
  addItemLabel: 'Add another item',
  addItemPlaceholder: 'e.g. treadmill, aquarium',
  addItemBtn: 'Add',
  remove: 'Remove',
  invUnsure: 'I’m not sure yet. Please help me confirm the list.',
  disassembly: 'Beds or other furniture need disassembly and reassembly',
  specialTitle: 'Heavy, fragile or special items',
  specialHelp: 'These get a quick review so we bring the right equipment and pricing.',
  invNotes: 'Notes about your items',
  errInventory: 'Add at least one item, or tell us you’re not sure yet',
  packTitle: 'Packing',
  packSelf: 'Moving only. I’ll have everything packed.',
  packSelfBody: 'You pack the boxes. Your crew still pads and wraps the furniture.',
  packPro: 'Moving with professional packing.',
  packProBody: 'Our crew packs with proper cartons, dividers and labels. Packing service and materials are priced separately.',
  packPrepNote: 'Boxes packed and furniture ready, or already taken apart, usually means less service time.',
  protectTitle: 'Careful packing for the belongings you want to keep',
  protect1: 'Padded blankets fitted around furniture',
  protect2: 'Reinforced corners and edges',
  protect3: 'Proper carton sizes for each item',
  protect4: 'Dish dividers that keep plates upright',
  protect5: 'Floors and doorways protected',
  protect6: 'Clear labels so unpacking is easy',
  protectNote: 'The same care on a local move as on a long one.',
  packProductsTitle: 'Choose packing help and supplies',
  pricedByTeam: 'Priced by our team',
  packTimeNote: 'Packing adds time on move day. We plan it into your crew’s schedule.',
  dateTitle: 'When would you like to move?',
  dateLabel: 'Requested date',
  dateUnsure: 'I’m not sure of the date yet',
  arrivalLabel: 'Preferred arrival window',
  arr8: '8 AM',
  arrNoon: 'Noon',
  arr3: '3 PM',
  arrOther: 'Another time',
  arrOtherLabel: 'What time works for you?',
  arrivalNote: 'This is your requested date and window. Your arrival window, crew and truck are confirmed by dispatch after booking.',
  anotherTimeCopy: 'Need another time? Tell us and we’ll check if extra capacity can be arranged. It stays a request until we confirm.',
  contactTitle: 'Where should we send your estimate?',
  firstName: 'First name',
  lastName: 'Last name',
  phone: 'Mobile number',
  email: 'Email',
  channelLabel: 'Best way to reach you',
  chCall: 'Phone call',
  chText: 'Text',
  chEmail: 'Email',
  consentQuote: 'I agree IMF Florida Local Movers may use these details to prepare and follow up on my moving quote.',
  consentSms: 'I agree to receive text messages from InstaMovers Florida (IMF Florida Local Movers) about this move: quote updates, scheduling, documents and booking status. Message frequency varies. Msg & data rates may apply. Reply STOP to opt out, HELP for help. Not required to get a quote. No marketing messages.',
  consentAi: 'You may call me about this move, including from the IMF Florida Local Movers AI-assisted phone line.',
  consentOptional: 'Optional',
  consentRequired: 'Required',
  errRequired: 'This field is required',
  errPhone: 'Enter a 10-digit US mobile number',
  errEmail: 'Enter a valid email address',
  errConsent: 'Please agree so we can prepare your quote',
  errZip: 'Enter a 5-digit ZIP code',
  errDate: 'Choose a date, or tell us you’re not sure yet',
  errArrival: 'Choose an arrival time',
  errPayer: 'Enter the payer’s name and email',
  estTitle: 'Your moving estimate',
  estSub: 'Hourly estimate, not a fixed price. Your final bill is based on actual service time and any changes you approve.',
  priceClear: 'Clear, itemized pricing before you reserve.',
  crewLabel: 'Crew',
  moversN: '{n} movers',
  recommended: 'Recommended',
  yourChoice: 'Your choice',
  crewPrefLabel: 'Crew size',
  crewRec: 'Recommended ({n})',
  crew2: '2 movers',
  crew3: '3 movers',
  crewPrefNote: 'Our team confirms {n} movers can handle this safely before your move.',
  serviceLabel: 'Estimated service time',
  hoursRange: '{a}–{b} hours',
  hoursN: '{n} h',
  minimumNote: '4-hour service minimum applies',
  rateLabel: '{n} movers + 1 truck',
  lineRate: 'Hourly rate',
  lineService: 'Service time (estimated)',
  lineTravel: 'Travel (base to your move and back)',
  lineLabor: 'Labor + travel',
  lineSurcharge: 'Operating surcharge (20%)',
  surchargePending: 'Not shown yet: the amount it is calculated on is still being confirmed',
  lineCardFee: 'Card payment charge ({p}%)',
  cardFeeNote: 'Applies only to amounts paid by card',
  lineTransport: 'Transportation for longer routes',
  transportValue: 'Estimated by our team before you pay',
  lineTotal: 'Estimated total',
  totalPending: 'Shown once the operating surcharge is configured',
  totalRange: 'Labor, travel and card charge so far: {a} – {b}',
  linePacking: 'Packing & materials',
  lineDeposit: 'Deposit payable now',
  depositCredit: 'Credited to your final bill. Not an extra charge.',
  lineRemaining: 'Estimated remaining',
  remainingNote: 'Before the operating surcharge and any extras. Your final bill follows actual time and approved changes.',
  rateByTeam: 'Set by our team for this crew size',
  reviewTitle: 'Our team will check a few details',
  rr_zone: 'Your route needs a service-area review',
  rr_transport: 'Longer routes need a transportation estimate. The 1 travel hour shown covers local travel only.',
  rr_special: 'Special items need the right equipment and pricing',
  rr_bigInventory: 'Your inventory is larger than typical for this home size',
  rr_large: 'Larger homes get a crew and truck review',
  rr_elevator: 'Elevator access needs a quick check',
  rr_stairsHigh: '4th floor or higher by stairs needs planning',
  rr_longCarry: 'A walk over 100 ft needs review',
  rr_crewPref: 'We’ll confirm your crew-size choice is safe for this move',
  rr_stops: 'Extra stops add drive and handling time. Our team plans the route with you.',
  rr_variantReview: 'One or more items (glass or stone tops, very large TVs) need a handling review.',
  rr_truckSmall: 'The truck size you picked may be small for your list. Our team will suggest an adjustment.',
  cr_1: 'Two movers usually handle a studio or 1-bedroom well, including upper-floor stairs.',
  cr_2: 'Two movers fit most 2-bedroom moves on the ground or 2nd floor.',
  cr_2_third: 'For a 2-bedroom up to the 3rd floor by stairs, three movers carry more safely and finish sooner.',
  cr_3: 'Three movers keep heavy pieces moving safely on most 3-bedroom moves. Two can work for a lighter, well-prepared list.',
  cr_3_upper: 'Upper-floor stairs with a 3-bedroom go safer and faster with three movers.',
  cr_45: 'Larger homes start with three movers. We review whether more help makes sense.',
  cr_elevator: 'Elevator time depends on the building. We review access to plan the right crew.',
  cr_stairsHigh: 'Four or more flights of stairs need careful planning. Our team confirms the crew.',
  acceptNote: 'Accepting saves this estimate version. If you change anything later, we’ll ask you to review it again.',
  reserveTitle: 'Review and reserve',
  reserveIntro: 'Here’s what applies to your booking before any payment.',
  staleTitle: 'Your estimate changed',
  staleBody: 'You edited your move after accepting the estimate. Please review the updated version.',
  staleBtn: 'Review updated estimate',
  versionLabel: 'Estimate version',
  docsTitle: 'Documents for this booking',
  docBooking: 'Booking agreement & terms',
  docDeposit: 'Deposit card authorization',
  docThird: 'Third-party cardholder authorization',
  docFull: 'Full balance authorization',
  docBol: 'Bill of Lading',
  whoYou: 'You',
  whoCardholder: 'Cardholder',
  whoPayer: 'Payer',
  whenNow: 'Before reservation',
  whenLater: 'On move day',
  docStatusNot: 'Sent by our team for secure signing',
  payerTitle: 'Who is paying?',
  payerMe: 'I’m paying',
  payerOther: 'Someone else is paying',
  payerName: 'Payer’s full name',
  payerEmail: 'Payer’s email',
  payerPhone: 'Payer’s mobile (optional)',
  methodTitle: 'Payment method',
  payCard: 'Card',
  payZelle: 'Zelle',
  zelleNote: 'Our team shares the Zelle details. After you send it, a team member verifies it with the bank. It shows as “Zelle verification pending” until then.',
  cancelTitle: 'Changes and cancellation',
  cancelBody: 'You can cancel or change your date with at least 72 hours’ notice. The exact refund terms are in your booking agreement, which you’ll see before paying.',
  reserve99: 'Reserve with $99',
  prepay: 'Prepay my estimated move',
  notAvailable: 'Not available online yet',
  requestEstimate: 'Send my move plan',
  requestNote: 'We’ll review your plan and contact you to confirm availability, documents and your $99 deposit.',
  submitting: 'Sending…',
  submitError: 'Something went wrong sending your request. Your answers are saved. Try again or call us.',
  retry: 'Try again',
  statusTitle: 'Your request',
  previewBanner: 'Preview mode: this request is saved on this device only and has not reached our team yet. Please call to finish it.',
  liveReceived: 'Request received. Our team will contact you.',
  refLabel: 'Reference',
  rowEstimate: 'Estimate',
  rowDocuments: 'Documents',
  rowDeposit: 'Deposit',
  rowDispatch: 'Dispatch',
  stAccepted: 'Accepted by you',
  stDocsNot: 'Not signed yet. Our team sends them.',
  stDepNot: 'Not paid',
  stDepZelle: 'Not paid. Zelle is verified by our team.',
  stDispatch: 'Requested date. Arrival window, crew and truck not confirmed yet.',
  nextTitle: 'What happens next',
  next1: 'Our team reviews your addresses, access and items.',
  next2: 'We confirm the date, crew and documents with you.',
  next3: 'Your move is confirmed only after documents, deposit and dispatch are complete.',
  newMove: 'Start another move',
  footerScope: 'Moves in Tampa, Orlando, Ocala, Sarasota and approved Florida routes.',
  footerStaff: 'Staff console',
  footerLegal: 'IMF Florida Local Movers is a service of InstaMovers Florida.',
  callFloating: 'Call IMF Florida Local Movers',
};

export type StringKey = keyof typeof en;
